import {
    RubricScoringType,
    RubricType,
} from '../../definitions/enums/rubricEnums';
import { GradingAction, GradingActionTypes } from '../actionTypes/grading';
import { EvaluationCriteria, EvaluationRubric, IGrading } from '../types';

const INIT_RUBRIC: EvaluationRubric = {
    title: '',
    type: RubricType.DefinedPoints,
    scoringType: RubricScoringType.NotSelected,
    maxPoints: '',
    criterias: new Array<EvaluationCriteria>(),
    addPointsManually: false,
    projectTypeNames: [],
    published: false,
};
const INIT_GRADING: IGrading = {
    rubrics: {
        scoring: INIT_RUBRIC,
        nonScoring: INIT_RUBRIC,
        presentationRubric: INIT_RUBRIC,
    },
    grading: [],
};

const GradingReducer = (
    state: IGrading = INIT_GRADING,
    action: GradingAction
) => {
    switch (action.type) {
        case GradingActionTypes.GET_GRADING:
            return action.payload;
        case GradingActionTypes.SAVE_GRADING:
            return { ...state, grading: [...action.payload.grading] };
        default:
            return state;
    }
};

export default GradingReducer;
